import { render, staticRenderFns } from "./display.vue?vue&type=template&id=5271c782&scoped=true&"
import script from "./display.vue?vue&type=script&lang=js&"
export * from "./display.vue?vue&type=script&lang=js&"
import style0 from "./display.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./display.vue?vue&type=style&index=1&id=5271c782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5271c782",
  null
  
)

export default component.exports